import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import * as _ from "lodash";
import { EpahafService } from "../epahaf/epahaf.service";
import { SecureStorageService } from "../../secure-storage.service";
import { Router } from '@angular/router';
import { CupService } from "../../shared/services/cup.service";

import{ Modal } from 'bootstrap';
@Component({
    selector: "app-eligibility-report",
    templateUrl: "./eligibility-report.component.html",
    styleUrls: ["./eligibility-report.component.scss"],
    standalone: false
})
export class EligibilityReportComponent implements OnInit {
  searchInput: string;
  allMemberDetails = [];
  loadingDashboard: boolean;
  data = [];
  checkedList = [];
  counter: number = 0;
  notChecked: boolean = true;
  username: any;
  memberdetailsData: any[];
  memberdetailsexcelData: any[];
  virtualLoadingMemberDetailData: string[];
  @ViewChildren("checkboxesSelect") checkboxesSelect: QueryList<ElementRef>;
  allFilterdData = [];
  selectedPCPItems = [];
  selectedHPItems = [];
  dropdownListPCP = [];
  dropdownListPCPlist:any[]=[];
  images: any = {
    logo: '',
    systolic: '',
    cancerScreening: '',
    signature: '',
    alogo: '',
    dlogo: '',
    ulogo: '',
    adulogo: '',
    diabetes: '',
    checkbox: '',
    rectBig: ''
  };
  dropdownSettingsPCP: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    classes: string;
  };

  dropdownSettingsHP: {
    singleSelection: boolean;
    text: string;
    selectAllText: string;
    unSelectAllText: string;
    enableSearchFilter: boolean;
    classes: string;
  };
  dropdownListHealthPlan = [];
  tempFilter2 = [];
  tempFilter = [];
  checkedReportList: any = []
  masterSelected: boolean;
  shortlistedAnthem =[];
  shortlistedHumana =[];
  dpdw = []
  tempDropdown = [];
  shortlistedAlignment = []
  shortlistedHealthNet = []
  shortlistedHTH = []
  shortlistedLACare = []
  shortlistedSCAN = []
  shortlistedUHC = []
  healthPlanList : any[] = ["Anthem", "Humana", "Alignment", "HealthNet", "HTH", "LA Care", "SCAN", "UHC"]

  constructor(private epahafService: EpahafService,private cupService:CupService,
    private secureStorage:SecureStorageService, private router:Router) { }

  ngOnInit() {
    this.masterSelected = false;
    // this.username = JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('currentUser'));
    // this.getMemberdetails(this.username.userName);
    this.username = this.cupService.getUserNameFromJWT();
    this.getMemberdetails(this.username);
    this.dropdownSettingsPCP = {
      singleSelection: false,
      text: "Select PCP",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
    };
    this.dropdownSettingsHP = {
      singleSelection: false,
      text: "Select Health Plan",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      classes: "myclass custom-class",
    };
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.virtualLoadingMemberDetailData.length; i++) {
      this.virtualLoadingMemberDetailData[i]['isSelected'] = this.masterSelected;
    }
    //console.log('virtualLoadingMemberDetailData :', this.virtualLoadingMemberDetailData)
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.virtualLoadingMemberDetailData.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }

  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedReportList = [];
    for (var i = 0; i < this.virtualLoadingMemberDetailData.length; i++) {
      if (this.virtualLoadingMemberDetailData[i]['isSelected'])      
        this.checkedReportList.push(this.virtualLoadingMemberDetailData[i]);
    }
    //this.checkedReportList = JSON.stringify(this.checkedReportList);
  }


  getSettings(placeholder: string) {
    try {
      return {
        text: '',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableCheckAll: (placeholder === 'GROUP' || placeholder === 'DATERANGE' || placeholder === 'RADIUS') ? false : true,
        enableFilterSelectAll: (placeholder === 'GROUP' || placeholder === 'DATERANGE' || placeholder === 'RADIUS') ? false : true,
        // enableSearchFilter: true,
        badgeShowLimit: 1,
        maxHeight: 160,
        singleSelection: (placeholder === 'DATERANGE' || placeholder === 'RADIUS') ? true : false,
        showCheckbox: placeholder === 'DATERANGE' ? false : true,
        position: 'bottom', autoPosition: false 
      };
    } catch (err) {
      throw err;
    }
  }
  handleResults(searchObj) {
    this.data = searchObj;
  }
  onItemSelect1(item: any) {
    //console.log(item);
    //console.log(this.selectedPCPItems);
    this.filterMembers();
  }
  OnItemDeSelect1(item: any) {
    if (
      this.selectedPCPItems.length === 0 &&
      this.selectedHPItems.length === 0
    ) {
      this.onDeSelectAll("");
    } else {
      this.filterMembers();
    }
  }
  OnItemDeSelect2(item: any) {
    this.filterMembers();
  }
  onSelectAll1(items: any) {
    this.filterMembers();
  }
  onDeSelectAll(items: any) {
    this.loadingDashboard = true;
    this.tempFilter2 = this.memberdetailsexcelData;
    if (this.tempFilter2.length) {
      if (this.tempFilter2.length > 50) {
        this.virtualLoadingMemberDetailData = this.tempFilter2.slice(0, 49);
        const displaysElement = document.getElementById('displays');
        if(displaysElement){
          displaysElement.classList.remove('d-none');
          displaysElement.classList.add('d-block');
        }
      } else {
        this.virtualLoadingMemberDetailData = this.tempFilter2;
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
      }
    } else if (this.tempFilter.length) {
      if (this.tempFilter.length > 50) {
        this.virtualLoadingMemberDetailData = this.tempFilter.slice(0, 49);
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-none');
          displaysElement.classList.add('d-block');
        }
      } else {
        this.virtualLoadingMemberDetailData = this.tempFilter;
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
      }
    } else {
      this.virtualLoadingMemberDetailData = [
        "No records found for the searched criteria",
      ];
      const displaysElement = document.getElementById('displays');
         
      if(displaysElement){
        displaysElement.classList.remove('d-block');
        displaysElement.classList.add('d-none');
      }
    }
    //console.log(this.virtualLoadingMemberDetailData.length);

    this.loadingDashboard = false;
  }
  onItemSelect2(item: any) {
    this.filterMembers();
  }

  onSelectAll2(items: any) {
    this.filterMembers();
  }

  filterMembers() {
    this.loadingDashboard = true;
    // this.tempFilter2 = [];
    if (this.selectedPCPItems.length > 0 && this.selectedHPItems.length === 0) {
      let arr1 = this.memberdetailsexcelData.filter((e) => {
        return this.selectedPCPItems.some(
          (item) => item.itemName === e.pcpName
        );
      });
      this.tempFilter2 = arr1;
    } else if (
      this.selectedHPItems.length > 0 &&
      this.selectedPCPItems.length === 0
    ) {
      let filteredItem: any = []
      let result = this.selectedHPItems.filter(item => {
        this.memberdetailsexcelData.filter((element) => {
          if (element.HealthPlan.indexOf(item.itemName) !== -1) {            
            filteredItem.push(element)
          }
        })      
      })
      
      this.tempFilter2 = filteredItem
    } else if (
      this.selectedPCPItems.length > 0 &&
      this.selectedHPItems.length > 0
    ) {
      let arr1 = this.memberdetailsexcelData.filter((e) => {
        return this.selectedPCPItems.some(
          (item) => item.itemName === e.pcpName
        );
      });
      

      // let arr2 = this.memberdetailsexcelData.filter((e) => {
      //   return this.selectedHPItems.some(
      //     (item) => item.itemName === e.HealthPlan
      //   );
      // });
      let arr2: any = []
      let result = this.selectedHPItems.filter(item => {
        this.memberdetailsexcelData.filter((element) => {
          if (element.HealthPlan.indexOf(item.itemName) !== -1) {            
            arr2.push(element)
          }
        })      
      })
      

      let arr3 = _.intersection(arr1, arr2);
      this.tempFilter2 = arr3;
    }
    if(this.selectedHPItems.length == 0 && this.selectedPCPItems.length == 0) {
      this.tempFilter2 = this.memberdetailsexcelData
    }

    this.allFilterdData = this.tempFilter2;
    if (this.tempFilter2.length) {
      if (this.tempFilter2.length > 50) {
        this.virtualLoadingMemberDetailData = this.tempFilter2.slice(0, 49);
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-none');
          displaysElement.classList.add('d-block');
        }
      } else {
        this.virtualLoadingMemberDetailData = this.tempFilter2;
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
      }
    } else if (this.tempFilter.length) {
      if (this.tempFilter.length > 50) {
        this.virtualLoadingMemberDetailData = this.tempFilter.slice(0, 49);
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-none');
          displaysElement.classList.add('d-block');
        }
      } else {
        this.virtualLoadingMemberDetailData = this.tempFilter;
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
      }
    } else {
      this.virtualLoadingMemberDetailData = [
        "No records found for the searched criteria",
      ];
      const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
    }

    this.loadingDashboard = false;
    this.getCheckedItemList();
  }

  onDeFilterPCP(item) {
    this.loadingDashboard = true;
    // this.tempFilter2 = [];

    this.tempFilter2.forEach((f) =>
      this.tempFilter2.splice(
        this.tempFilter2.findIndex((e) => e.pcpName === item.itemName),
        1
      )
    );




    this.allFilterdData = this.tempFilter2;


    if (this.tempFilter2.length) {
      if (this.tempFilter2.length > 50) {
        this.virtualLoadingMemberDetailData = this.tempFilter2.slice(0, 49);
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-none');
          displaysElement.classList.add('d-block');
        }
      } else {
        this.virtualLoadingMemberDetailData = this.tempFilter2;
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
      }
    } else {
      this.virtualLoadingMemberDetailData = [
        "No records found for the searched criteria",
      ];
      const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
    }
    //console.log(this.virtualLoadingMemberDetailData.length);

    this.loadingDashboard = false;
  }
  onDeFilterHP(item) {
    this.loadingDashboard = true;

    this.tempFilter2.forEach((f) =>
      this.tempFilter2.splice(
        this.tempFilter2.findIndex((e) => e.HealthPlan === item.itemName),
        1
      )
    );

    this.allFilterdData = this.tempFilter2;

    if (this.tempFilter2.length) {
      if (this.tempFilter2.length > 50) {
        this.virtualLoadingMemberDetailData = this.tempFilter2.slice(0, 49);
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-none');
          displaysElement.classList.add('d-block');
        }
      } else {
        this.virtualLoadingMemberDetailData = this.tempFilter2;
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
      }
    } else {
      this.virtualLoadingMemberDetailData = [
        "No records found for the searched criteria",
      ];
      const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
    }
    

    this.loadingDashboard = false;
  }

  _filterMembers(event: any, data?) {
    let reg = new RegExp(this.escapeRegex(this.searchInput), "gi");
    //console.log("reg", reg);
    this.loadingDashboard = true;
    let tempFilter = [];
    let tempFilter2 = [];
    this.memberdetailsexcelData.map((data) => {
      if (reg.test(data.pcpName) || reg.test(data.HealthPlan)) {
        tempFilter2.push(data);
      } else {
        tempFilter.push(data);
      }
      this.allFilterdData = tempFilter2;
    });

    if (this.searchInput && tempFilter2.length) {
      if (tempFilter2.length > 50) {
        this.virtualLoadingMemberDetailData = tempFilter2.slice(0, 49);
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-none');
          displaysElement.classList.add('d-block');
        }
      } else {
        this.virtualLoadingMemberDetailData = tempFilter2;
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
      }
    } else if (!this.searchInput && tempFilter.length) {
      if (tempFilter.length > 50) {
        this.virtualLoadingMemberDetailData = tempFilter.slice(0, 49);
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-none');
          displaysElement.classList.add('d-block');
        }
      } else {
        this.virtualLoadingMemberDetailData = tempFilter;
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
      }
    } else {
      this.virtualLoadingMemberDetailData = [
        "No records found for the searched criteria",
      ];
      const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
    }
    //console.log(this.virtualLoadingMemberDetailData.length);

    this.loadingDashboard = false;
  }
  escapeRegex(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  }
  loadmoreData() {
    this.loadingDashboard = true;
    let tempData = [];
    let startIndex = this.virtualLoadingMemberDetailData.length;
    let endIndex = this.virtualLoadingMemberDetailData.length + 50;    
    if (this.allFilterdData.length > 0) {      
      if (endIndex < this.allFilterdData.length) {
        for (let i = startIndex; i < endIndex; i++) {
          tempData.push(this.allFilterdData[i]);
        }
      } else {
        for (
          let i = this.virtualLoadingMemberDetailData.length;
          i < this.allFilterdData.length;
          i++
        ) {
          tempData.push(this.allFilterdData[i]);
        }
      }

      this.virtualLoadingMemberDetailData =
        this.virtualLoadingMemberDetailData.concat(tempData);
      if (
        this.virtualLoadingMemberDetailData.length ===
        this.allFilterdData.length
      ) {
        const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
      }
    } else {      
      if (endIndex < this.memberdetailsData.length) {        
        for (let i = startIndex; i < endIndex; i++) {
          tempData.push(this.memberdetailsData[i]);
        }
      } else {        
        for (
          let i = this.virtualLoadingMemberDetailData.length;
          i < this.memberdetailsData.length;
          i++
        ) {
          tempData.push(this.memberdetailsData[i]);
        }

      }
      this.virtualLoadingMemberDetailData =
        this.virtualLoadingMemberDetailData.concat(tempData);
        if (
          this.virtualLoadingMemberDetailData.length ===
          this.memberdetailsData.length
        ) {
          const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
        }
    }
    this.loadingDashboard = false;

    if(this.masterSelected) {
      this.checkUncheckAll();
    }
  }
  getMemberdetails(name, type?, searchedMember?) {
    this.loadingDashboard = true;
    let temp = [];
    let memberArray;
    this.memberdetailsData = [];
    this.memberdetailsexcelData = [];
    this.virtualLoadingMemberDetailData = ["loading..."];
    let duplicatesPcp = [];
    let allHp = [];
    // let statusRes = await this.epahafService.getUserCompleteStatus();

    // let responseData: any;
    // if (statusRes._body) {
    //   responseData = JSON.parse(statusRes._body);
    //   memberArray = responseData.responseDatasArray;
    // }

    this.epahafService.getEligibilityDetails(name).subscribe(
      (Response) => {
        //console.log("Response :",Response)
        
          let ResponseData: any;
          ResponseData = Response;
          if (ResponseData.length > 0) {
            //console.log("ResponseData :",ResponseData);
            ResponseData.map((element, index) => {
              let obj: any = {};
              obj.npi = element.NPI;
              obj.pcpName = element.pcpName;
              obj.group = element.GROUP_IPA_POD_NAME;
              obj.ipa =
                element.afflicationdescription +
                "[" +
                element.Affiliation +
                "]";
              obj.memberHmoID = element.memberHmoID;
              obj.fullName =
                element.memberFirstName + "" + element.memberLastName;
              obj.memberDOB = this.convertDateFormat(element.memberDOB);
              obj.HealthPlan = element.Plandescription;

              obj.index = index;
              obj.Affiliation = element.Affiliation;
              obj.age = this.calculateAge(element.memberDOB);
              obj.startDate = element.Memberproducteffectivedate;
              obj.endDate = element.MemberproductTermdate;
              obj.firstName = element.memberFirstName;
              obj.lastName = element.memberLastName;
              obj.addressLine1 = element.AddressLine1.slice(5);
              obj.addressLine2 = element.AddressLine2;
              obj.city = element.City;
              obj.stateCode = element.statecode;
              obj.zip = element.ZipCode;
              obj.tinMarket = element.TINMarket;
              obj.tinState = element.Tin_State;
              obj.planDesc = element.Plandescription;
              obj.subGrpName = element.SubGroupName;
              obj.pcpeffDate = element.PCPeffdate;
              obj.provId = element.PRPR_ID;
              obj.gender = element.Gender;
              obj.phonenum = element.memberContactNumber;
              this.memberdetailsexcelData.push(obj);

              if (!duplicatesPcp.includes(element.pcpName)) {
                duplicatesPcp.push(element.pcpName);
                this.dropdownListPCP.push({
                  id: index,
                  itemName: element.pcpName,
                });
                this.dropdownListPCPlist= this.dropdownListPCP;
              }
              if (!allHp.includes(element.Plandescription)) {
                allHp.push(element.Plandescription);

                this.dropdownListHealthPlan.push({
                  id: index,
                  itemName: element.Plandescription,
                }); 
                
                this.dpdw.push(element.Plandescription);
              }
              //  temp.push(obj);              
            });

            let uniqueDropDownList: any = []
            uniqueDropDownList = [...this.dropdownListHealthPlan]
            // this.healthPlanList.filter(item => {
              // this.dropdownListHealthPlan.filter((element) => {
              //   if (element.itemName.indexOf(item) !== -1) {            
              //     uniqueDropDownList.push({
              //       id: element.id,
              //       itemName: item,
              //     })
              //   }
              // })      
            // })
            this.dropdownListHealthPlan = [...new Map(uniqueDropDownList.map(item =>[item['itemName'], item])).values()]

            
            if (
              this.memberdetailsexcelData &&
              this.memberdetailsexcelData.length
            ) {
              this.memberdetailsexcelData.map((data) => {
                this.memberdetailsData.push(data);

                if (temp && temp.length <= 49) {
                  temp.push(data);
                }
                //}
              });
              setTimeout(() => {
                if (temp && temp.length) {
                  this.virtualLoadingMemberDetailData = temp;

                  this.loadingDashboard = false;
                } else {
                  this.virtualLoadingMemberDetailData = [
                    "No records found for the searched criteria",
                  ];
                  this.loadingDashboard = false;
                }
              }, 20);
            }
          } else {
            this.loadingDashboard = false;
            this.memberdetailsData = ["No Data found "];
            this.virtualLoadingMemberDetailData = ["No Data found "];
            this.memberdetailsexcelData = ["No Data found "];
          }

          if (this.memberdetailsData.length >= 49) {
            const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-none');
          displaysElement.classList.add('d-block');
        }
          } else {
            const displaysElement = document.getElementById('displays');
         
        if(displaysElement){
          displaysElement.classList.remove('d-block');
          displaysElement.classList.add('d-none');
        }
          }
        

        //this.notChecked = true;
      },
      (err) => {
        this.loadingDashboard = false;
        // this.notChecked = true;
        this.memberdetailsData = ["No Data found "];
        this.virtualLoadingMemberDetailData = ["No Data found "];
        this.memberdetailsexcelData = ["No Data found"];
      }
    );
  }
  public convertDateFormat(str) {
    try {
      if (str) {
        var month = str.slice(5, 7);
        var date = str.slice(8, 10);
        var year = str.slice(0, 4);
        var totalDate = month + "/" + date + "/" + year;
        return totalDate;
      } else {
        return "";
      }
    } catch (err) {
      throw err;
    }
  }
  isChecked(id: number, affilation) {
    for (let index = 0; index < this.checkedList.length; index++) {
      if (
        id == this.checkedList[index].memberHmoID &&
        affilation == this.checkedList[index].group
      ) {
        return true;
      }
    }
    return false;
  }
  calculateAge(dob) {
    var today = new Date();
    var birthDate = new Date(dob);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age = age - 1;
    }

    return age;
  }

  selectedMember(memberDetails, type, event?) {
    //this.medicationList = [];
    // $(".innerRows").hide();
    
    if (type !== "selectAll") {
      if (event.target.checked === true) {
        this.notChecked = false;
        if (this.counter < 50) {
          this.counter++;
        } else {
          event.target.checked = false;
          alert("Please select only 5 members.");
        }
      } else if (this.counter > 0) {
        this.counter--;
      }
    }
    if (event.target.checked) {
      // this.loadingDashboard = true;
      this.checkedList.push(memberDetails);
      this.notChecked = false;      
    } else if (!event.target.checked) {
      this.masterSelected = false;
      if (this.counter == 0) {
        this.notChecked = true;
      }
      this.checkedList = this.checkedList.filter(
        (x) =>
          x.memberHmoID !== memberDetails.memberHmoID &&
          x.ipa !== memberDetails.ipa
      );
    }
    this.masterSelected = this.virtualLoadingMemberDetailData.every(function(item:any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }
  generateExcelReport() {
    this.loadingDashboard = true;
    this.generateEligibiltyReport();
    this.loadingDashboard = false;
  }

  goToHome()
  {
    this.router.navigate(['providerportal/portal']);
  }

  async generateEligibiltyReport() {
    //let formattedMember = this.checkedList.map((eachData) => {
      let formattedMember = this.checkedReportList.map((eachData) => {
      let obj = [
        eachData.memberHmoID,
        eachData.startDate,
        eachData.endDate,
        eachData.pcpeffDate, 
        eachData.firstName,
        eachData.lastName,
        eachData.group,
        eachData.addressLine1,
        eachData.addressLine2,
        " ",
        " ",
        " ",
        " ",
        eachData.city,
        eachData.stateCode,
        eachData.zip,
        "",
        eachData.phonenum,
        eachData.gender,
        eachData.memberDOB,
        eachData.age,
        eachData.npi,
        eachData.provId,
        eachData.pcpName,
        eachData.tinMarket,
        eachData.tinState,
        eachData.HealthPlan,
        eachData.subGrpName,               
      ];
      return obj;
    });
    const memberDetailsTitle = "Member Eligibility  Report";
    const detailsHeader = this.getCsvFileHeader();

    const headerStyle = {
      font:  { bold: true, color: { rgb: "FFFFFF" } },
      fill:  { fgColor: { rgb: "23499E" }, patternType: "solid" },
      border: {
        top:    { style: "thin", color: { rgb: "FFFFFF" } },
        left:   { style: "thin", color: { rgb: "FFFFFF" } },
        bottom: { style: "thin", color: { rgb: "FFFFFF" } },
        right:  { style: "thin", color: { rgb: "FFFFFF" } },
      },
      alignment: { vertical: "center", wrapText: true },
    };

    const titleStyle = {
      font:      { bold: true, sz: 16 },
      alignment: { horizontal: "left", vertical: "center", wrapText: true },
    };

    const dataStyle = {
      alignment: { vertical: "center", wrapText: true },
    };

    // Build rows: title row, blank row, header row, data rows
    const titleRow   = [{ v: memberDetailsTitle, s: titleStyle }];
    const blankRow   = [''];
    const headerRow  = detailsHeader.map((h: string) => ({ v: h, s: headerStyle }));
    const dataRows   = formattedMember.map((row: any[]) =>
      row.map((cell: any) => ({ v: cell ?? '', s: dataStyle }))
    );

    const wsData = [titleRow, blankRow, headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Column widths
    ws['!cols'] = [
      { wch: 15 }, { wch: 15 }, { wch: 18 }, { wch: 18 }, { wch: 15 },
      { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 10 }, { wch: 10 },
      { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 },
      { wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 15 }, { wch: 20 },
      { wch: 15 }, { wch: 10 }, { wch: 20 }, { wch: 20 }, { wch: 20 },
      { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 15 },
    ];

    // Merge title across columns A1:A1 (single title cell)
    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: detailsHeader.length - 1 } }];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, "Eligibility  Report");

    const xlsxBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([xlsxBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Member Eligibility Report.xlsx");
  }

  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
  
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
  
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
  
        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
  
      img.onerror = error => {
        reject(error);
      };
      img.src = url;
    });
  }
  public getCsvFileHeader() {
    return [
      " Member ID",
      "	Effective Start Date",
      "	Effective Termination Date",
      "PCP Effective Date ",
      "First Name",
      "Last Name	",
      "AFFILIATED GROUP/ IPA  ",
      "Line 1 Address",
      "	Line 2 Address",
      "Line 3 Address",
      "Line 4 Address",
      "	Line 5 Address",
      "Line 6 Address",
      "City",
      "USPS State Code",
      "	Zip 5",
      "Zip 4",
      "Phone number",
      "Gender",
      "Date of Birth",
      "Age",
      "	PCP NPI",
      "Provider ID PCP",
      "PCP Name",
      "	Neighborhood",
      "State",
      "Plan Desc",
      "Subgroup Name",            
    ];
  }
  openModal(modalId: string) {
    const modal = new Modal(document.getElementById(modalId));
    modal.show();
  }
}
